/**
 * @sort id
 * @sort name
 * @sort address
 * @sort g_branch_office_id
 * @sort wh_warehouse_type_id
 * @sort is_waste_warehouse
 */
export default [
    {
        text: '#',
        value: 'id',
        sortable: true,
    },
    {
        text: 'nombre',
        value: 'name',
        sortable: true,
    },
    {
        text: 'dirección',
        value: 'address',
        sortable: true,
    },
    {
        text: 'sucursal',
        value: 'g_branch_office_name',
        //sortable: "g_branch_office_id",
    },
    {
        text: 'tipo',
        value: 'wh_warehouse_type_name',
        sortable: 'wh_warehouse_type_id',
        align: 'center',
        component: {
            type: 'chip',
            props: {
                disabled: true,
                label: true,
                small: true,
                textColor: 'black',
            },
        },
    },
    {
        text: 'bodega merma',
        value: 'is_waste_warehouse',
        sortable: true,
        align: 'center',
        format: 'boolean',
    },
    {
        text: 'fecha de creación',
        value: 'created_at',
        format: 'datetime',
    },
]
